import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  'title': {
    id: 'license.controls.title',
    description: 'License controls title',
    defaultMessage: 'Controls',
  },
  'activationButtonLabel': {
    id: 'license.controls.activation.button.label',
    description: 'Label for license activation button',
    defaultMessage: 'Activate',
  },
  'deactivationButtonLabel': {
    id: 'license.controls.deactivation.button.label',
    description: 'Label for license deactivation button',
    defaultMessage: 'Deactivate',
  },
  'deactivationConfirmTitle': {
    id: 'license.controls.deactivation.confirm.title',
    description: 'License deactivation confirmation dialog title',
    defaultMessage: 'Deactivate license?',
  },
  'licenseBrokenTitle': {
    id: 'license.controls.brokenLicense.title',
    description: 'License controls title when the current license is in a broken state.',
    defaultMessage: 'License is in a broken state',
  },
  'deactivationConfirmYes': {
    id: 'license.controls.deactivation.confirm.button.yes.label',
    description: 'Label for license deactivation confirm yes -button',
    defaultMessage: 'Yes',
  },
  'deactivationConfirmNo': {
    id: 'license.controls.deactivation.confirm.button.no.label',
    description: 'Label for license deactivation confirm no -button',
    defaultMessage: 'No',
  },
  'upgradeButtonLabel': {
    id: 'license.controls.update.button.label',
    description: 'Label for license upgrade button',
    defaultMessage: 'Upgrade',
  },
  'fixButtonLabel': {
    id: 'license.controls.fix.button.label',
    description: 'Label for license fix button',
    defaultMessage: 'Fix license',
  },
  'cantUpgradePendingWarning': {
    id: 'license.warning.noPendingUpgrade',
    description: 'Warning pending license can not be upgraded.',
    defaultMessage: 'Pending license can not be upgraded. Deactivate the pending license first and then activate new license.',
  },
  'licenseBrokenWarning': {
    id: 'license.warning.broken.license',
    description: 'Warning that the current license is in a broken state and must be fixed.',
    defaultMessage: 'It appears that the license is in broken state. This may be the result of e.g. failed activation. The license state must be fixed before proceeding. You can fix the license with the button below. If the fix fails, please contact administration.',
  }
});
